import { request } from 'client/modules/common/utils/request';

export const impersonateUser = (req: any) =>
  request({
    url: '/api/impersonate-user',
    body: req,
  }).then((r) => r.body);
